import * as utility from "@sharedJS/stickyElementUtility";
import breakpoints from "@sharedJS/breakpoints";

function init() {
	_initFixedReturnSummary();
}

// fixed sticky
//-------------------------------

function _initFixedReturnSummary() {
	const $window = $(window);
	let $stickyElement;
	let $spacingElement;

	const stickyBreakpoint = `${breakpoints["l_down"]} and (min-width: 375px)`;

	if (Modernizr.mq(stickyBreakpoint)) {
		$stickyElement = $(".js-return-summary-price");
		$spacingElement = $(".js-return-summary-price-spacing");
	}

	if ($stickyElement && $spacingElement) {
		utility.fixedStickyElement($stickyElement, $spacingElement);
		$window.scroll(() => {
			utility.fixedStickyElement($stickyElement, $spacingElement);
		});
	}
}

export { init };
